module.exports = __webpack_public_path__ + "img/background_roadmap.60935b72.webp";